import { Checkbox, Shadow, Switch, Text, HStack, VStack } from '@genial/components';
import { BoxRadius, Spacing, Typography } from '@genial/design-tokens';
import { Utils, useBreakpointValue } from '@genial/utils';
import React from 'react';

import { SendingChannelItemProps } from '../../../../../../hooks/useSendingChannels';

interface SendingChannelProps {
  sendingChannelsOptions: SendingChannelItemProps[];
  sendingChannelsSelected: string[];
  onChannelSelectChange: (value: string, selected: boolean) => void;
}

export const SendingChannel: React.FC<SendingChannelProps> = ({
  onChannelSelectChange,
  sendingChannelsOptions,
  sendingChannelsSelected,
}) => {
  const isDesktop = useBreakpointValue({ base: false, sm: true });
  const isMobile = useBreakpointValue({ base: true, sm: false });

  return (
    <VStack pt={Spacing['inline.xxs']}>
      <Shadow level={1} borderTopRadius={BoxRadius.sm}>
        {isDesktop && (
          <VStack
            p={{ sm: Spacing['stack.xxs'] }}
            borderBottomWidth={{ sm: '1px' }}
            borderBottomColor="neutral.light">
            <HStack alignItems="center" justifyContent="space-between">
              <Text
                fontSize={Typography['fontsize.lg']}
                variant="semibold"
                color="brand.primary.principal">
                Conclua sua boleta
              </Text>
            </HStack>
          </VStack>
        )}
        {isMobile && (
          <VStack bg={['neutral.white']} p={Spacing['inline.xxs']} space={Spacing['stack.nano']}>
            <Text
              paddingBottom={Spacing['inset.nano']}
              fontWeight={Typography['fontweight.semibold']}
              fontSize={Typography['fontsize.md']}>
              Canal de envio
            </Text>
            <VStack space={Spacing['inset.xs']}>
              {sendingChannelsOptions.map((channel) => (
                <HStack key={channel.value} justifyContent={'space-between'} alignItems="center">
                  <Text fontSize={Typography['fontsize.md']}>{channel.label}</Text>
                  <Switch
                    onToggle={(value: boolean) => onChannelSelectChange(channel.value, value)}
                    isChecked={sendingChannelsSelected.includes(channel.value)}
                    disabled={channel.disabled}
                  />
                </HStack>
              ))}
            </VStack>
          </VStack>
        )}
        {isDesktop && (
          <HStack
            py={Spacing['inline.xxxs']}
            px={Spacing['inline.xxs']}
            alignItems="center"
            justifyContent={'space-between'}>
            <VStack space={Spacing['inline.quarck']}>
              <Text
                variant="semibold"
                fontSize={Typography['fontsize.md']}
                color={'neutral.black'}
                lineHeight={'distant'}>
                Selecione o canal de envio
              </Text>
              <Checkbox
                hasError={false}
                testId="channel-checkbox"
                options={sendingChannelsOptions}
                onChange={onChannelSelectChange}
                selectedValues={sendingChannelsSelected}
              />
            </VStack>
            <VStack space={Spacing['inline.quarck']} alignItems={'flex-end'}>
              <Text
                variant="semibold"
                fontSize={Typography['fontsize.md']}
                color={'neutral.black'}
                lineHeight={'distant'}>
                Data de Envio
              </Text>
              <Text
                variant="regular"
                fontSize={Typography['fontsize.md']}
                color={'neutral.black'}
                lineHeight={'distant'}>
                {Utils.Mask.DateFormat(new Date(), 'dd/MM/yyyy')}
              </Text>
            </VStack>
          </HStack>
        )}
      </Shadow>
    </VStack>
  );
};
